// extracted by mini-css-extract-plugin
export default {"content":"appRoot_content__muVC8","bar_icon":"appRoot_bar_icon__4j8Vm","logo_wrapper":"appRoot_logo_wrapper__7PJ84","container":"appRoot_container__nBfa8"};